import {
    ApptReasonCode,
} from './model';

import {
    SET,
    REINIT
} from './types';

import {
    Actions,
} from './actions';

/**
 *
 * @param context contains settings.json etc
 * @param initial initial state if set
 */
export const apptreasoncode = (
    context: any,
    initial?: ApptReasonCode,
) => {
    let initialstate = initial || {};
    return (
        state: ApptReasonCode,
        action: Actions,
    ) => {
        const {
            type,
            payload,
        } = action;

        let updated = state || initialstate;
        switch (type) {
            case SET:
                updated = {
                    ...payload,
                }
                break;
            case REINIT:
                updated = {
                    ...initialstate
                }
                break;
        }
        return updated;
    }
};
